<template>
  <div class="container">
    <div class="board">
      <div class="close"><a v-on:click="close"><img :src="`${publicPath}/images/icons/x.svg`" class="icon"></a></div>
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in currentPlates()" :key="index"><answer-component :answer-name="item" :answer-index="index" :plate-number="plateNumber"></answer-component></swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnswerSlideComponent',
  data: function(){
    return {
      swiperOption: {
        initialSlide: this.answerIndex,
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        }
      }
    }
  },
  props: {
    answerName: {
      default: '',
      type: String
    },
    answerIndex: {
      default: 0,
      type: Number
    },
    plateNumber: {
      default: 0,
      type: Number
    }
  },
  methods: {
    close: function() {
      this.changeView({
        viewName: 'AnswerListComponent',
        plateNumber: this.plateNumber,
        transitionName: 'top'
      })
    }
  }
}
</script>
